// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fC3t","rootNoMargin":"styles_rootNoMargin__1OcVE"};